import React from "react";
import { createRoot } from "react-dom/client";

import { App } from "@/core/app";
import { initI18n } from "@/core/i18n";
import { initDatadog } from "@core/monitoring";

initDatadog();

initI18n();

const renderApp = () => {
  createRoot(document.getElementById("root") as HTMLElement).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  );
};

if (import.meta.env.VITE_E2E === "true") {
  void import("@/test/e2e-bootstrap").then(({ startE2EBootstrap }) =>
    startE2EBootstrap().then(renderApp),
  );
} else {
  renderApp();
}
